import React, { useMemo } from "react";
import themePropTypes from "../theme-prop-types";

const Container = ({
  field,
  fieldRef,
  children,
  containerButtonProps,
  ariaProps = {},
  experiments,
  additionalClassName
}) => {
  const { updatedLayout } = field;

  const { label: srLabel, ...ariaAttributes } = useMemo(
    () => ariaProps,
    [ariaProps]
  );

  const getClassName = useMemo(
    () =>
      `${field.name} ${field.type} ${
        field.params ? field.params.split("|").join(" ") : ""
      } ${additionalClassName.filter(Boolean).join(" ")}` +
      `${
        Object.values(containerButtonProps).length &&
        !containerButtonProps?.disabled
          ? ""
          : " inactive"
      }` +
      `${updatedLayout?.["background-color"] ? " select" : ""}`,
    [
      field.name,
      field.type,
      field.params,
      field.options,
      updatedLayout,
      additionalClassName
    ]
  );

  const childToRender = srLabel ? (
    <div aria-hidden='true' className='container-content'>
      {children}
    </div>
  ) : (
    children
  );

  let styles = {};
  if (updatedLayout) {
    const borderColor = updatedLayout?.["border-color"] || "";
    const borderThickness = updatedLayout?.["border-thickness"];
    styles = {
      border: `${borderThickness}px solid ${borderColor.replace("0x", "#")}`
    };
  }

  const step_fields = ["step1", "step2", "step3", "step4"];
  if (step_fields.includes(field.name)) {
    let background_color_web = field.layout["background-color"].replace(
      "0x",
      "#"
    );
    styles["background-color"] = background_color_web;
  }

  if (field.name === "web_progress_filler") {
    styles.width = field.layout?.width;
  }

  return containerButtonProps?.role === "button" &&
    containerButtonProps?.disabled ? (
    <button
      type='button'
      className={`container-web-sdk ${getClassName}`}
      style={styles}
      {...containerButtonProps}
      disabled={containerButtonProps?.disabled}
      {...ariaAttributes}
      ref={fieldRef}
    >
      {children}
    </button>
  ) : (
    <div
      className={`container-web-sdk ${getClassName}`}
      style={styles}
      {...containerButtonProps}
      {...experiments}
      disabled={containerButtonProps?.disabled}
      {...ariaAttributes}
      ref={fieldRef}
    >
      {childToRender}
      {srLabel && <div className='websdk-sr-only'>{srLabel}</div>}
    </div>
  );
};

Container.propTypes = themePropTypes.container;

export default Container;
